/*! TITANORE AB TEST — CHEFS PAN — VARIANT B */
(function () {
  'use strict';

  /* Kill competing sitewide sticky if a cached global script still injects it */
  function killSitewideSticky() {
    var bar = document.getElementById('tgem-shop-sticky');
    if (bar) bar.remove();
    document.body.classList.remove('tgem-shop-sticky-pad');
  }
  killSitewideSticky();
  [200, 600, 1200, 2500].forEach(function (ms) {
    window.setTimeout(killSitewideSticky, ms);
  });

  var root = document.querySelector('[data-tcpb-root]');
  if (!root) return;

  var EXPERIMENT = {
    experiment_name: 'chefs_pan_page_test',
    experiment_variant: 'B'
  };

  function track(eventName, payload) {
    var data = Object.assign({}, EXPERIMENT, payload || {}, { event: eventName });
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, Object.assign({}, EXPERIMENT, payload || {}));
      }
    } catch (e2) {}
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('tcpb:analytics', { detail: data })
      );
    } catch (e3) {}
  }

  function centsFromLabel(s) {
    if (!s) return 0;
    var t = String(s).replace(/[^\d,.]/g, '');
    if (!t) return 0;
    if (t.indexOf(',') >= 0 && t.indexOf('.') >= 0) {
      t = t.replace(/\./g, '').replace(',', '.');
    } else if (t.indexOf(',') >= 0) {
      t = t.replace(',', '.');
    }
    var n = parseFloat(t);
    if (!isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  function stickySaveLabel(price, was) {
    var now = centsFromLabel(price);
    var orig = centsFromLabel(was);
    if (!orig || orig <= now) return '';
    var pct = Math.round((1 - now / orig) * 100);
    var save = orig - now;
    if (pct < 1) return '';
    return '-' + pct + '% · \u2212\u20ac' + Math.round(save / 100);
  }

  function currentLang() {
    var path = (location.pathname || '').toLowerCase();
    if (path === '/nl' || path.indexOf('/nl/') === 0) return 'nl';
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
        var wg = Weglot.getCurrentLang();
        if (wg) return wg;
      }
    } catch (e) {}
    var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (htmlLang.indexOf('nl') === 0) return 'nl';
    return 'en';
  }

  function applyI18n(scope) {
    var key = currentLang() === 'nl' ? 'nl' : 'en';
    (scope || root).querySelectorAll('[data-en][data-nl]').forEach(function (el) {
      var next = el.getAttribute('data-' + key) || el.getAttribute('data-en');
      if (next != null) el.textContent = next;
    });
  }

  applyI18n(root);

  /* Optional real countdown — only if ISO deadline is present & future */
  var countdownEl = root.querySelector('[data-tcpb-countdown]');
  var deadlineRaw = root.getAttribute('data-sale-deadline') || '';
  if (countdownEl && deadlineRaw) {
    var end = Date.parse(deadlineRaw);
    if (!isNaN(end) && end > Date.now()) {
      countdownEl.hidden = false;
      function tick() {
        var ms = end - Date.now();
        if (ms <= 0) {
          countdownEl.hidden = true;
          return;
        }
        var s = Math.floor(ms / 1000);
        var d = Math.floor(s / 86400);
        s -= d * 86400;
        var h = Math.floor(s / 3600);
        s -= h * 3600;
        var m = Math.floor(s / 60);
        s -= m * 60;
        var pad = function (n) {
          return (n < 10 ? '0' : '') + n;
        };
        countdownEl.textContent =
          pad(d) + 'd : ' + pad(h) + 'u : ' + pad(m) + 'm : ' + pad(s) + 's';
        window.setTimeout(tick, 1000);
      }
      tick();
    } else {
      countdownEl.hidden = true;
    }
  }

  var CART_SECTION = 'cart-drawer';
  var sticky = document.querySelector('[data-tcpb-sticky]');
  var stageImg = root.querySelector('[data-tcpb-stage-img]');

  function findDrawerHost() {
    return (
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('[id*="cart-drawer" i]') ||
      document.querySelector('.cart-drawer')
    );
  }

  function replaceDrawerHtml(html) {
    if (!html) return false;
    var wrap = document.createElement('div');
    wrap.innerHTML = String(html).trim();
    var next =
      wrap.querySelector('cart-drawer') ||
      wrap.querySelector('#shopify-section-cart-drawer') ||
      wrap.querySelector('#CartDrawer') ||
      wrap.firstElementChild;
    if (!next) return false;
    var host = findDrawerHost();
    if (!host) return false;
    var section = host.closest('.shopify-section') || host;
    if (next.id && next.id.indexOf('shopify-section') === 0 && section.classList.contains('shopify-section')) {
      section.outerHTML = next.outerHTML;
    } else if (host.tagName && host.tagName.toLowerCase() === 'cart-drawer') {
      host.outerHTML = (wrap.querySelector('cart-drawer') || next).outerHTML;
    } else {
      host.innerHTML = next.innerHTML || next.outerHTML;
    }
    var drawer = findDrawerHost();
    if (drawer) {
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();
      else {
        drawer.classList.add('active', 'is-open', 'animate');
        document.body.classList.add('overflow-hidden');
      }
      return true;
    }
    return false;
  }

  function refreshDrawer() {
    return fetch('/?sections=' + encodeURIComponent(CART_SECTION), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('section_fetch_failed');
        return r.json();
      })
      .then(function (data) {
        return replaceDrawerHtml(data && data[CART_SECTION]);
      });
  }

  function setButtonLabel(btn, text) {
    if (!btn) return;
    var label = btn.querySelector('[data-tcpb-cta-label]');
    if (label) label.textContent = text;
    else btn.textContent = text;
  }

  function getButtonLabel(btn) {
    if (!btn) return '';
    var label = btn.querySelector('[data-tcpb-cta-label]');
    return label ? label.textContent : btn.textContent;
  }

  function addToCart(btn, source) {
    if (!btn || btn.disabled) return;
    var variantId = parseInt(btn.getAttribute('data-variant') || '', 10);
    var href = btn.getAttribute('data-href') || '/products/titanium-hammered-pan-pro-medium';
    if (!variantId) {
      window.location.href = href;
      return;
    }
    var prev = getButtonLabel(btn);
    btn.disabled = true;
    setButtonLabel(btn, 'Bezig…');
    track(
      source === 'sticky'
        ? 'sticky_add_to_cart'
        : source === 'set'
          ? 'pannenset_add_to_cart'
          : 'hero_add_to_cart',
      {
        variant_id: variantId,
        source: source || 'hero'
      }
    );
    var add = (typeof window.tlAddCookware === 'function')
      ? window.tlAddCookware(variantId, { sections: CART_SECTION, sections_url: window.location.pathname })
      : fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: CART_SECTION,
            sections_url: window.location.pathname
          })
        }).then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          return r.json();
        });
    add
      .then(function (data) {
        if (data && data.busy) {
          btn.disabled = false;
          setButtonLabel(btn, prev);
          return;
        }
        if (typeof window.tlShouldSkipToCheckout === 'function' ? window.tlShouldSkipToCheckout() : false) {
          window.location.assign(typeof window.tlCheckoutHref === 'function' ? window.tlCheckoutHref() : '/nl/checkout?skip_shop_pay=true');
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        if (data && data.sections && data.sections[CART_SECTION]) {
          if (replaceDrawerHtml(data.sections[CART_SECTION])) {
            btn.disabled = false;
            setButtonLabel(btn, prev);
            return;
          }
        }
        return refreshDrawer().then(function (ok) {
          if (!ok) window.location.href = '/cart';
          else {
            btn.disabled = false;
            setButtonLabel(btn, prev);
          }
        });
      })
      .catch(function () {
        window.location.href = href || '/cart';
      });
  }

  /* Single source of truth for size selection — syncs title, price, CTA, media, sticky */
  function selectSize(btn) {
    if (!btn) return;
    var lang = currentLang() === 'nl' ? 'nl' : 'en';
    root.querySelectorAll('[data-tcpb-size]').forEach(function (el) {
      var on = el === btn;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    var price = btn.getAttribute('data-price') || '';
    var was = btn.getAttribute('data-was') || '';
    var save = btn.getAttribute('data-save') || '';
    var href = btn.getAttribute('data-href') || '';
    var variant = btn.getAttribute('data-variant') || '';
    var label = btn.getAttribute('data-label-' + lang) || btn.getAttribute('data-label-en') || '';
    var dia = btn.getAttribute('data-dia') || '';
    var preview = btn.getAttribute('data-preview') || '';
    var thumb = btn.getAttribute('data-img') || '';
    var name = btn.getAttribute('data-name') || label;
    var title = 'Chef’s Pan — ' + name;

    var titleEl = root.querySelector('[data-tcpb-title]');
    var nowEl = root.querySelector('[data-tcpb-price-now]');
    var wasEl = root.querySelector('[data-tcpb-price-was]');
    var saveEl = root.querySelector('[data-tcpb-save]');
    var diaEl = root.querySelector('[data-tcpb-dia]');
    var cta = root.querySelector('[data-tcpb-cta]');
    var midCta = root.querySelector('[data-tcpb-mid-cta]');
    var midSize = root.querySelector('[data-tcpb-mid-size]');
    var midPrice = root.querySelector('[data-tcpb-mid-price]');
    var midImg = root.querySelector('[data-tcpb-mid-img]');

    if (titleEl) titleEl.textContent = title;
    if (nowEl) nowEl.textContent = price;
    if (wasEl) {
      wasEl.textContent = was;
      wasEl.hidden = !was;
    }
    if (saveEl) {
      if (save) {
        saveEl.hidden = false;
        saveEl.textContent = lang === 'nl' ? 'Je bespaart ' + save : 'You save ' + save;
      } else {
        saveEl.hidden = true;
      }
    }
    if (diaEl && dia) diaEl.textContent = 'Ø ' + dia;

    if (cta) {
      if (href) cta.setAttribute('data-href', href);
      if (variant) cta.setAttribute('data-variant', variant);
      setButtonLabel(cta, 'In winkelwagen — ' + price);
    }
    if (midCta) {
      if (href) midCta.setAttribute('data-href', href);
      if (variant) midCta.setAttribute('data-variant', variant);
      midCta.textContent = 'In winkelwagen — ' + price;
    }
    if (midSize) midSize.textContent = title + (dia ? ' · Ø ' + dia : '');
    if (midPrice) midPrice.textContent = price;
    if (midImg && thumb) midImg.src = thumb;

    if (stageImg && preview) {
      stageImg.src = preview;
      stageImg.alt = title;
    }

    if (sticky) {
      var sSize = sticky.querySelector('[data-tcpb-sticky-size]');
      var sNow = sticky.querySelector('[data-tcpb-sticky-now]');
      var sWas = sticky.querySelector('[data-tcpb-sticky-was]');
      var sSave = sticky.querySelector('[data-tcpb-sticky-save]');
      var sCta = sticky.querySelector('[data-tcpb-sticky-cta]');
      var sImg = sticky.querySelector('[data-tcpb-sticky-img]');
      if (sSize) sSize.textContent = label;
      if (sNow) sNow.textContent = price;
      if (sWas) {
        sWas.textContent = was;
        sWas.hidden = !was;
      }
      if (sSave) {
        var saveTxt = stickySaveLabel(price, was);
        sSave.textContent = saveTxt;
        sSave.hidden = !saveTxt;
      }
      if (sImg && thumb) sImg.src = thumb;
      if (sCta) {
        if (href) sCta.setAttribute('data-href', href);
        if (variant) sCta.setAttribute('data-variant', variant);
      }
    }

    track('variant_selected', {
      variant_id: variant,
      label: label,
      price: price
    });
  }

  root.querySelectorAll('[data-tcpb-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectSize(btn);
    });
  });

  root.querySelectorAll('[data-tcpb-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-tcpb-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === btn);
      });
      var src = btn.getAttribute('data-src');
      if (stageImg && src) {
        stageImg.src = src;
        stageImg.hidden = false;
      }
    });
  });

  var heroCta = root.querySelector('[data-tcpb-cta]');
  if (heroCta) {
    heroCta.addEventListener('click', function () {
      addToCart(heroCta, 'hero');
    });
  }

  var midCtaBtn = root.querySelector('[data-tcpb-mid-cta]');
  if (midCtaBtn) {
    midCtaBtn.addEventListener('click', function () {
      addToCart(midCtaBtn, 'mid');
    });
  }

  if (sticky) {
    var stickyCta = sticky.querySelector('[data-tcpb-sticky-cta]');
    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        addToCart(stickyCta, 'sticky');
      });
    }
    var hero = root.querySelector('[data-tcpb-hero]');
    if (hero && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var on = !entry.isIntersecting;
            sticky.classList.toggle('is-on', on);
            document.body.classList.toggle('tcpb-sticky-pad', on);
          });
        },
        { threshold: 0.05 }
      );
      io.observe(hero);
    }
  }

  /* Pannenset tracking + ATC */
  function bindSets() {
    var sets = root.querySelector('[data-tcpb-sets]');
    if (!sets) return;
    if ('IntersectionObserver' in window) {
      var seen = false;
      var sio = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !seen) {
              seen = true;
              track('pannenset_view', {});
            }
          });
        },
        { threshold: 0.25 }
      );
      sio.observe(sets);
    }
    sets.addEventListener(
      'click',
      function (e) {
        var setCta = e.target && e.target.closest ? e.target.closest('[data-tcpb-set-cta]') : null;
        if (setCta && sets.contains(setCta)) {
          e.preventDefault();
          e.stopPropagation();
          addToCart(setCta, 'set');
          return;
        }
        var a = e.target && e.target.closest ? e.target.closest('a[data-tcpb-set-card]') : null;
        if (a && sets.contains(a)) {
          track('pannenset_click', {
            href: a.getAttribute('href') || '',
            label: (a.textContent || '').trim().slice(0, 80),
            set: a.getAttribute('data-set') || ''
          });
        }
      },
      true
    );
  }
  bindSets();

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/checkout"]') : null;
      if (a) track('begin_checkout', { href: a.getAttribute('href') });
    },
    true
  );

  /* Default Medium selected — keep lifestyle hero until user picks a size */
  var initial = root.querySelector('[data-tcpb-size].is-selected') || root.querySelector('[data-tcpb-size]');
  if (initial) {
    var keepHero = stageImg ? stageImg.getAttribute('src') : '';
    selectSize(initial);
    if (stageImg && keepHero) {
      stageImg.src = keepHero;
      root.querySelectorAll('[data-tcpb-thumb]').forEach(function (t, i) {
        t.classList.toggle('is-active', i === 0);
      });
    }
  }
})();
